import {
  useReadNotification,
  useUnreadNotification,
} from "@/api/notifications";
import { Checkbox } from "@/components/ui/checkbox";
import getNestedValue from "@/utils/helper/getNestedValue";

export default function NotificationReadCheckboxCell({
  rowValue,
  name,
}: {
  rowValue: {
    [x: string]: unknown;
  };
  name: string;
}) {
  const { mutate: read } = useReadNotification();
  const { mutate: unread } = useUnreadNotification();

  const isRead = getNestedValue(rowValue, name) as boolean;
  const id = getNestedValue(rowValue, "id") as string;

  const toggleNotificationStatus = () => {
    isRead ? unread({ id }) : read({ id });
  };

  return (
    <Checkbox checked={isRead} onCheckedChange={toggleNotificationStatus} />
  );
}
